/**
 * Crypt Dice Factory
 *
 * Creates color-specific crypt dice components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * CryptDiceComponent with per-color schemes.
 */

import React from 'react';
import type { DiceProps } from '../basics/constants/types';
import CryptDiceComponent from './CryptDiceComponent';
import { CRYPT_DICE_COLOR_SCHEMES, type CryptDiceColorScheme } from './constants/diceColorSchemes';

type DiceColor = 'red' | 'blue' | 'yellow' | 'green';

function createCryptDice(color: DiceColor) {
  const colorScheme: CryptDiceColorScheme = CRYPT_DICE_COLOR_SCHEMES[color];
  const displayName = `Crypt${color.charAt(0).toUpperCase() + color.slice(1)}Dice`;

  const ColoredDice = React.memo(function ColoredDice(props: DiceProps) {
    return <CryptDiceComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredDice.displayName = displayName;
  return ColoredDice;
}

export const RedDice = createCryptDice('red');
export const BlueDice = createCryptDice('blue');
export const YellowDice = createCryptDice('yellow');
export const GreenDice = createCryptDice('green');
